import type { FC } from "react"
import { useEffect } from "react"
import {
  Box,
  Button,
  Flex,
  Icon,
  MenuItem,
  useClipboard,
} from "@chakra-ui/react"

import { Copy } from "ui/components/icons/font-awesome/Copy"
import { useLocation } from "common/hooks/useLocation"
import { useToast } from "common/hooks/useToast"

type ProposalShareMenuItemProps = {
  url: string
}

const ProposalShareMenuItem: FC<ProposalShareMenuItemProps> = ({ url }) => {
  const { origin } = useLocation()

  const { onCopy, setValue } = useClipboard("")
  const { toast } = useToast()

  useEffect(() => {
    if (origin) {
      setValue(`${origin}${url}`)
    }
  }, [origin, setValue, url])

  const handleCopyUrl = () => {
    onCopy()
    toast({
      status: "success",
      title: "URL copied to clipboard",
    })
  }

  return (
    <MenuItem as={Box}>
      <Button
        leftIcon={<Icon as={Copy} />}
        size="sm"
        variant="tertiary"
        width="100%"
        onClick={handleCopyUrl}
      >
        <Flex width="100%">Copy URL</Flex>
      </Button>
    </MenuItem>
  )
}

export default ProposalShareMenuItem
